import { useSound } from '@/contexts/SoundContext';
import { useEffect } from 'react';

export function useButtonSounds() {
  const { playButtonClick, playButtonHover } = useSound();

  useEffect(() => {
    // Add sound handlers to all buttons
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      // Check if target is an element with matches method
      if (target && target.nodeType === 1) {
        if ((target.matches && target.matches('button, .btn')) || target.closest?.('button, .btn')) {
          playButtonClick();
        }
      }
    };

    const handleMouseEnter = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      // Check if target is an element with matches method
      if (target && target.nodeType === 1) {
        if ((target.matches && target.matches('button, .btn')) || target.closest?.('button, .btn')) {
          playButtonHover();
        }
      }
    };

    // Use capture phase for better performance
    document.addEventListener('click', handleClick, { capture: true, passive: true });
    document.addEventListener('mouseenter', handleMouseEnter, { capture: true, passive: true });

    return () => {
      document.removeEventListener('click', handleClick, { capture: true });
      document.removeEventListener('mouseenter', handleMouseEnter, { capture: true });
    };
  }, [playButtonClick, playButtonHover]);
}
